var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.91 28.021v0c.997 0 1.805-.808 1.805-1.806V9.16a2.087 2.087 0 0 0-2.087-2.087h-9.283",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.99 10.38h3.4c.094 0 .183.037.25.103l3.509 3.51a.353.353 0 0 1 .103.249V29.2a2.087 2.087 0 0 1-2.087 2.087H11.801A2.087 2.087 0 0 1 9.714 29.2V18.388M25.586 8.697h2.02c.195 0 .353.158.353.353v1.98M21.84 8.697h2.335",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.536 27.448v-3.8c0-.316.257-.572.573-.572h.93c.317 0 .573.256.573.573v3.799a.573.573 0 0 1-.573.573h-.93a.573.573 0 0 1-.573-.573zM15.142 27.447V21.53c0-.316.257-.573.573-.573h.93c.317 0 .573.257.573.573v5.918a.573.573 0 0 1-.573.573h-.93a.573.573 0 0 1-.573-.573zM18.748 27.448v-8.39c0-.317.256-.573.573-.573h.93c.316 0 .573.256.573.573v8.39a.573.573 0 0 1-.573.573h-.93a.573.573 0 0 1-.573-.573zM22.354 27.448V16.232c0-.316.257-.573.573-.573h.93c.317 0 .573.257.573.573v11.216a.573.573 0 0 1-.573.573h-.93a.573.573 0 0 1-.573-.573z",
    fill: "#31B59F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.64 28.02h1.869M15.245 28.02h1.87M18.851 28.02h1.87M22.457 28.02h1.87",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.209 3.714-.965-1.199M3.635 6.021 2.11 5.816M7.799 2.666l.123-1.534",
    stroke: "#31B59F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.43 13.889c-.411 0-.802-.069-1.173-.206a1.952 1.952 0 0 1-.65-.402c-.167-.155-.136-.417.036-.567.2-.174.509-.124.72.037.077.06.163.113.255.16.26.13.531.202.811.215v-2.482a4.634 4.634 0 0 1-.733-.254 2.777 2.777 0 0 1-.625-.4 1.771 1.771 0 0 1-.42-.557 1.795 1.795 0 0 1-.157-.772 1.788 1.788 0 0 1 .577-1.339c.182-.17.39-.303.625-.4a2.21 2.21 0 0 1 .733-.186v-.41a.235.235 0 1 1 .47 0v.41c.351 0 .696.065 1.035.195.201.076.382.175.544.298.193.146.173.428-.007.591-.173.158-.442.128-.63-.012a1.499 1.499 0 0 0-.24-.144 1.514 1.514 0 0 0-.703-.166V9.93c.26.085.515.176.762.274.248.097.466.221.655.371.196.143.349.322.46.537.117.215.175.482.175.802a1.83 1.83 0 0 1-.615 1.397c-.183.17-.398.303-.645.4a2.64 2.64 0 0 1-.792.177v.459a.235.235 0 0 1-.469 0v-.46zm0-6.391c-.32.059-.577.192-.773.4-.189.203-.283.46-.283.773 0 .169.026.312.078.43.059.117.134.218.225.302.097.085.208.16.332.225.13.059.27.117.42.176V7.498zm.468 5.628c.332-.039.61-.166.83-.38.229-.216.343-.48.343-.792 0-.176-.033-.33-.098-.46a1.011 1.011 0 0 0-.264-.332 1.469 1.469 0 0 0-.38-.224 3.093 3.093 0 0 0-.43-.167v2.355z",
    fill: "#31B59F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.007 4.862a6.422 6.422 0 1 0 1.773 1.613",
    stroke: "#333",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.636 5.416 14.182 5l-.456-1.534",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.741 .21)",
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayReport);
export default __webpack_public_path__ + "static/media/pay-report.17c6550ea1b00a25e32af769bf0d8532.svg";
export { ForwardRef as ReactComponent };